import { useState, useEffect } from "react";
import axios from 'axios';
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import { Link } from "react-router-dom";
import Header from "../../Common/Layout/Header";
import SideBar from "../../Common/Layout/Sidebar";

const initialValues = {
    heroId: "00000000-0000-0000-0000-000000000000",
    title: "",
    description: "",
    backgroundColor: "",
    buttonText: "",
    buttonLink: "",
    buttonColor: ""
};

export default function HeroSection() {
    const [values, setValues] = useState(initialValues);
    const [errors, setErrors] = useState({});
    const [isEditMode, setIsEditMode] = useState(false);
    const [originalData, setOriginalData] = useState(null);
    const headerconfig = {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("userToken")
        }
    };

    useEffect(() => {
        getHero();
    }, []);

    const getHero = () => {
        axios.get(config.APIACTIVATEURL + config.GETHERO, headerconfig)
            .then(res => {
                if (res.data.data.length > 0) {
                    setValues(res.data.data[0]);
                    setOriginalData(res.data.data[0]);
                }
            })
            .catch(err => console.log(err));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setValues({ ...values, [name]: value });
    };

    const validate = () => {
        let temp = {};
        temp.title = values.title ? true : false;
        temp.description = values.description ? true : false;
        setErrors(temp);
        return Object.values(temp).every(x => x === true);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            const payload = {
                ...values,
                updatedDate: new Date().toISOString()
            };

            axios.put(
                `${config.APIACTIVATEURL}${config.UPDATEHERO}/${values.heroId}`,
                payload,
                headerconfig
            )
                .then(res => {
                    if (res.data.statusCode === 200) {
                        handleSuccess("Record Updated");
                        setIsEditMode(false);
                        getHero();
                    } else {
                        handleError(res.data.message);
                    }
                })
                .catch(err => {
                    console.error(err);
                    handleError("Update failed");
                });
        }
    };

    const handleCancel = () => {
        setValues(originalData);
        setIsEditMode(false);
    };

    const applyErrorClass = (field) =>
        field in errors && errors[field] === false ? " is-invalid" : "";

    return (
        <div id="layout-wrapper">
            <Header />
            <SideBar />
            <div className="body-wrapper">
                <div className="container-fluid">
                    <div className="layout-wrapper mb-5 mt-3">
                        <div className="landing" style={{ backgroundColor: values.backgroundColor }}>
                            <section className="section nft-hero" style={{ backgroundColor: values.backgroundColor }}>
                                <div className="container">
                                    <div className="row justify-content-center">
                                        <div className="col-12">
                                            <div className="text-center">
                                                <h4 className="outfitslider mb-4 lh-base text-white">
                                                    {values.title.split("<br />").map((line, i) => (
                                                        <div key={i}>{line}</div>
                                                    ))}
                                                </h4>

                                                <p className="lead text-white lh-base pb-2 outfitp">
                                                    {values.description}
                                                </p>
                                                <div className="hstack gap-2 justify-content-center">
                                                    <Link to={values.buttonLink} className="btn" style={{ backgroundColor: values.buttonColor, color: "#fff" }}>
                                                        {values.buttonText}
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h4 className="card-title">Hero Section Settings</h4>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Title</label>
                                                <textarea
                                                    name="title"
                                                    value={values.title}
                                                    onChange={handleInputChange}
                                                    className={`form-control${applyErrorClass("title")}`}
                                                    rows={1}
                                                    readOnly={!isEditMode}
                                                />
                                                {errors.title === false && (
                                                    <div className="invalid-feedback">Title is required</div>
                                                )}
                                            </div>

                                            <div className="col-md-12 mb-3">
                                                <label className="form-label">Description</label>
                                                <textarea
                                                    name="description"
                                                    value={values.description}
                                                    onChange={handleInputChange}
                                                    className={`form-control${applyErrorClass("description")}`}
                                                    rows={2}
                                                    readOnly={!isEditMode}
                                                />
                                                {errors.description === false && (
                                                    <div className="invalid-feedback">Description is required</div>
                                                )}
                                            </div>

                                            <div className="col-md-3 mb-3">
                                                <label className="form-label">Background Color</label>
                                                <input
                                                    type="color"
                                                    name="backgroundColor"
                                                    value={values.backgroundColor}
                                                    onChange={handleInputChange}
                                                    className="form-control form-control-color"
                                                    disabled={!isEditMode}
                                                />
                                            </div>

                                            <div className="col-md-3 mb-3">
                                                <label className="form-label">Button Color</label>
                                                <input
                                                    type="color"
                                                    name="buttonColor"
                                                    value={values.buttonColor}
                                                    onChange={handleInputChange}
                                                    className="form-control form-control-color"
                                                    disabled={!isEditMode}
                                                />
                                            </div>

                                            <div className="col-md-3 mb-3">
                                                <label className="form-label">Button Text</label>
                                                <input
                                                    type="text"
                                                    name="buttonText"
                                                    value={values.buttonText}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                    readOnly={!isEditMode}
                                                />
                                            </div>

                                            <div className="col-md-3 mb-3">
                                                <label className="form-label">Button Link</label>
                                                <input
                                                    type="text"
                                                    name="buttonLink"
                                                    value={values.buttonLink}
                                                    onChange={handleInputChange}
                                                    className="form-control"
                                                    readOnly={!isEditMode}
                                                />
                                            </div>

                                            <div className="col-12 mt-3 d-flex justify-content-end gap-2">
                                                {isEditMode ? (
                                                    <>
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            onClick={handleCancel}
                                                        >
                                                            Cancel
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className="btn btn-primary"
                                                        >
                                                            Save Changes
                                                        </button>
                                                    </>
                                                ) : (
                                                    <button
                                                        type="button"
                                                        className="btn btn-warning"
                                                        onClick={() => setIsEditMode(true)}
                                                    >
                                                        Edit
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
